import createIcon from '../../createIcon';

/**
 * @component @name ShoppingCartCheckout
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxOEM2LjkgMTggNi4wMSAxOC45IDYuMDEgMjBDNi4wMSAyMS4xIDYuOSAyMiA4IDIyQzkuMSAyMiAxMCAyMS4xIDEwIDIwQzEwIDE4LjkgOS4xIDE4IDggMThaTTE4IDE4QzE2LjkgMTggMTYuMDEgMTguOSAxNi4wMSAyMEMxNi4wMSAyMS4xIDE2LjkgMjIgMTggMjJDMTkuMSAyMiAyMCAyMS4xIDIwIDIwQzIwIDE4LjkgMTkuMSAxOCAxOCAxOFpNOS4xIDEzSDE2LjU1QzE3LjMgMTMgMTcuOTYgMTIuNTkgMTguMyAxMS45N0wyMiA0Ljk2TDIwLjI1IDRMMTYuNTUgMTFIOS41M0w1LjI3IDJIMlY0SDRMNy42IDExLjU5TDYuMjUgMTQuMDNDNS41MiAxNS4zNyA2LjQ4IDE3IDggMTdIMjBWMTVIOEw5LjEgMTNaTTEzIDJMMTcgNkwxMyAxMEwxMS41OSA4LjU5TDEzLjE3IDdIOVY1SDEzLjE3TDExLjU4IDMuNDFMMTMgMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShoppingCartCheckout = createIcon('ShoppingCartCheckout', [
  [
    'path',
    {
      d: 'M8 18C6.9 18 6.01 18.9 6.01 20C6.01 21.1 6.9 22 8 22C9.1 22 10 21.1 10 20C10 18.9 9.1 18 8 18ZM18 18C16.9 18 16.01 18.9 16.01 20C16.01 21.1 16.9 22 18 22C19.1 22 20 21.1 20 20C20 18.9 19.1 18 18 18ZM9.1 13H16.55C17.3 13 17.96 12.59 18.3 11.97L22 4.96L20.25 4L16.55 11H9.53L5.27 2H2V4H4L7.6 11.59L6.25 14.03C5.52 15.37 6.48 17 8 17H20V15H8L9.1 13ZM13 2L17 6L13 10L11.59 8.59L13.17 7H9V5H13.17L11.58 3.41L13 2Z',
      key: '80160y',
    },
  ],
]);

export default ShoppingCartCheckout;
